<section class="flex flex-column w-full">
  <div class="filter-buttons flex">
    <!-- <button
      (click)="op.toggle($event)"
      type="button"
      pButton
      class="main-btn mr-3"
    >
      {{ openFilterBtnText }} <i class="pi pi-search"></i>
    </button> -->
  </div>
</section>

<!-- <p-overlayPanel #op [showCloseIcon]="true" [style]="{ width: '40vw' }">
  <ng-template pTemplate> -->
<app-form-factory styleClass="mt-2" [form]="searchForm" [fields]="fieldsService"></app-form-factory>
<!-- </ng-template>
</p-overlayPanel> -->
<button (click)="resetFilter()" type="button" pButton class="main-btn mr-1">Reset<i class="pi pi-refresh"></i></button>
